import UploadFiles from './UploadFiles';

export type { ImageUpload } from './model';
export default UploadFiles;
